// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ivan-setting-page[data-v-65b56689]{height:100%;padding:8px 12px 0;display:flex;flex-direction:column;overflow:hidden}.ivan-setting-page>.row[data-v-65b56689]{margin:0;flex:0 0 auto}.table-area[data-v-65b56689]{flex:1 1 auto;min-height:0;overflow:auto;height:calc(100% - 60px)}.table-area[data-v-65b56689] tbody tr{cursor:pointer}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
